import React, { useEffect } from 'react';
import { useState } from 'react';
// import BigNumber from 'bignumber.js';
import { useTranslation, setDefaults } from 'react-i18next';

import HeaderBackdrop from './HeaderBackdrop.jsx';
import DarkModeToggle from '../DarkModeToggle/DarkModeToggle.js';

import {
    LIQUIDITY_POOL2_URL, 
    BLEND_SUPPLY_URL,
} from '../../App.js';

import classes from './HeaderModal.module.css';

const HeaderModal = (props) => {
    const { 
        showModal, 
        hideModalHandler,
    } = props;
    // console.log('HeaderModal-props', props);

    const [showModal2, setShowModal2] = useState(false);
    const [installStyle, setInstallStyle] = useState('none');

    const { t, i18n } = useTranslation();

    useEffect(() => {
        window.addEventListener('DOMContentLoaded', () => {
            console.log('in DOMContentLoaded');
            let displayMode = 'browser tab';
            if (navigator.standalone) {
                displayMode = 'standalone-ios';
            }
            if (window.matchMedia('(display-mode: standalone)').matches) {
                displayMode = 'standalone';
            }
            // Log launch display mode to analytics
            console.log('DISPLAY_MODE_LAUNCH:', displayMode);
        });

        // const addBtn = document.getElementById('add-button');
        // console.log('addBtn headermodal', addBtn);
        // addBtn.style.display = 'none';

        // window.addEventListener('beforeinstallprompt', (event) => {
        //   console.log('beforeinstallprompt fired installhandler headermodal');
        //   event.preventDefault();
        //   // deferredPrompt = event;
        //   console.log('in beforeinstallprompt', event);
        //   // addBtn.style.display = 'block';

        //   // props.d.driverFbUser.handlers.setDeferredPrompt(event);
        //   console.log('driver deferredPrompt', props.d.driverFbUser.deferredPrompt);
        //   setInstallStyle('block');

        // });
    });

    // const fbfsSignOutHandler = () => {
    //   firebase.auth().onAuthStateChanged(function (user) {
    //     if (user) {
    //       // User is signed in.
    //       firebase.database().ref('users/' + user.uid).update({
    //         pass2fa: false
    //       }, function (error) {
    //         if (error) {
    //           console.log('error occured in pass2fa false');
    //         } else {
    //           console.log('user pass2fa false');

    //           firebase.auth().signOut().then(function () {
    //             // Sign-out successful.
    //             console.log('fb sign out success');
    //             localStorage.removeItem('fb-token-expiration');
    //             localStorage.removeItem('fb-token');
    //             localStorage.removeItem('fbfs-token');

    //             props.fbUserStateHandler({
    //               state: 'signout'
    //             });

    //             props.d.session.handlers.logout();

    //             props.hideModalHandler();
    //             // setFbDisplayname('');
    //             // setFbUserId('');
    //             // setfbEmailVerification(false);

    //           }).catch(function (error) {
    //             // An error happened.
    //             console.log(error);
    //           });

    //         }
    //       });

    //     } else {
    //       // No user is signed in.
    //       console.log('no fb user');
    //       props.d.session.handlers.logout();
    //     }
    //   });

    // }

    const moveHomePageHandler = () => {
        const wl = window.location;
        window.location.href = wl.protocol + '//' + wl.host + '/#fbsignin';
    };

    const logoutConfirmHandler = () => {
        if (window.confirm(`Is it no problem to logout? ${t('subNav.text5')}?`)) {
            // fbfsSignOutHandler();
            moveHomePageHandler();
        }
    };

    // const installHandler = () => {
    //   const deferredPrompt = props.d.driverFbUser.deferredPrompt;
    //   console.log('in installHandler', deferredPrompt);

    //   if (deferredPrompt) {
    //     deferredPrompt.prompt();

    //     deferredPrompt.userChoice
    //       .then((choiceResult) => {
    //       console.log(choiceResult.outcome);
    //       if (choiceResult.outcome === 'dismissed') {
    //         console.log('user canceled install');
    //       } else {
    //         console.log('user added to home screen');
    //         setInstallStyle('none');
    //         props.hideModalHandler();
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    //     // deferredPrompt = null;
    //   }
    // }

    let headerModal;
    let headerModalStyle;
    if (showModal) {
        headerModalStyle = {
            position: 'fixed',
            width: '60%',
            maxWidth: '300px',
            // width: "90%",
            // height: "30%",
            maxHeight: '80%',
            // left: "58%",
            right: '1%',
            // top: "8vh",
            top: '60px',
            // background: "white",
            background: 'var(--island-background)',
            borderRadius: '5px',
            zIndex: '500',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.26)',
            fontSize: '',
            fontWeight: 'bolder',
            // opacity: props.showModal ? "1" : "0"
            padding: '10px',
            overflowY: 'auto',
        };

        const modalEmelntStyle = {
            padding: '15px',
            textAligne: 'right',
        };

        headerModal = (
            <div style={headerModalStyle}>
                {/* modal at Header */}
                {/* <div style={modalEmelntStyle} >
          <LanguageSelector />
        </div> */}

                {/* <div style={modalEmelntStyle}>
          <a href="https://app.spaceeight.work" 
            target="_blank"
            rel="nofollow noopener noreferrer"
            style={{ color:"var(--color)", textDecoration: "none" }}
          >
            StellarSpaceM
            <br />
            (mobile Wallet and DEX)
          </a>
        </div> */}

                <div style={modalEmelntStyle}>
                    <a
                        style={{ color: 'var(--color)', textDecoration: 'none' }}
                        // href={`https://buy.moonpay.io/`}
                        // href={'https://dokmpxlmdeposit.spaceeight.net/'}
                        href={'https://deposit.spaceeight.work'}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                    >
                        <span>StellarSpace Deposit</span>
                        {/* <img src={images['icon-visa-mc']} height="40" alt="credit-card" /> */}
                        <br />
                        <sapn style={{ fontSize: '' }}>(Buy XLM)</sapn>
                    </a>
                    {/* <img src="data:image/svg+xml;base64,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" /> */}
                </div>

                <div style={modalEmelntStyle}>
                    <a
                        href="https://www.spaceeight.work"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        style={{ color: 'var(--color)', textDecoration: 'none' }}
                    >
                        {/* <a href="https://stellarspace-33722.web.app" target="_blank" style={{ textDecoration: "none" }}> */}
                        StellarSpace
                        <br />
                        (SDEX & AMM liquidity pools)
                    </a>
                </div>

                <div style={modalEmelntStyle}>
                    <a
                        href="https://stellar-nftplace.spaceeight.work"
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        style={{ color: 'var(--color)', textDecoration: 'none' }}
                    >
                        {/* <a href="https://stellarspace-33722.web.app" target="_blank" style={{ textDecoration: "none" }}> */}
                        Stellar NFT Place
                        <br />
                        (Create, Trade NFT)
                    </a>
                </div>

                {/* <div style={modalEmelntStyle}>
                    <a
                        href={LIQUIDITY_POOL2_URL}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        style={{ color: 'var(--color)', textDecoration: 'none' }}
                    >
                        Liquidity Pool2
                    </a>
                </div>
                <div style={modalEmelntStyle}>
                    <a
                        href={BLEND_SUPPLY_URL}
                        target="_blank"
                        rel="nofollow noopener noreferrer"
                        style={{ color: 'var(--color)', textDecoration: 'none' }}
                    >
                        Interest Earning
                    </a>
                </div> */}

                <div style={modalEmelntStyle}>
                    <DarkModeToggle
                        hideModalHandler={hideModalHandler}
                        // setDarkMode={setDarkModeHandler}
                    />
                </div>

                {/* <div onClick={props.showModal2Handler}>xxx</div> */}
                {/* <div onClick={() => {clickHandler()}}>clicked?</div> */}
                {props.children}
            </div>
        );
    }

    return (
        <div>
            <HeaderBackdrop showModal={showModal} clicked={hideModalHandler} />

            <div>{headerModal}</div>
            {/* {headerModal2} */}
        </div>
    );
};

export default HeaderModal;
